<mat-chip-list #usersSelectedList [selectable]="false" [ngStyle]="{'pointer-events': _disabled ? 'none' : 'default'}">
	<mat-chip *ngFor="let user of _values" disableRipple [removable]="!_disabled" (removed)="onDeselectUser(user)" [disabled]="_disabled">
		<img alt="illustration" matChipAvatar [src]="(user?.picture | apiUrl) || 'assets/account-circle.svg'" loading="lazy" />
		{{user.nomComplet}}
		<mat-icon matChipRemove *ngIf="!_disabled">cancel</mat-icon>
	</mat-chip>
	<input matInput #usersInputElement [formControl]="inputControl" [matAutocomplete]="usersSelection" [placeholder]="placeholder" 
		[ngStyle]="{width: 'auto', display: shouldHideInput ? 'none' : 'block', flex: '1 0 auto'}">
</mat-chip-list>
<mat-autocomplete #usersSelection="matAutocomplete" (optionSelected)="onSelectUser($event)" (closed)="inputControl.reset()" (opened)="onOpened(usersSelection)"
    panelWidth="auto" autoActiveFirstOption>
	<mat-option disabled *ngIf="inputState.isWaiting">
		<div class="app-pong" style="width: 250px;">
            <div class="app-pong-dot"></div>
            <div class="app-pong-dot"></div>
            <div class="app-pong-dot"></div>
        </div>
	</mat-option>
	<mat-option disabled *ngIf="!inputState.isWaiting && !inputState.isTyping && !inputList.length && inputControl.value?.length > 2">
		Aucun résultat
	</mat-option>
	<mat-option *ngFor="let user of inputList" [value]="user" [disabled]="(_disableWithoutGUID && (!user.guid || !user.isActive))"
		style="align-items: stretch; padding-top: 8px">
		<div fxLayoutAlign="start center" fxLayoutGap="16px">
			<mat-user-picture size="32" fxFlexAlign="start" [src]="user.picture | apiUrl"
				[matBadge]="user?.connection?.icon" matBadgeSize="small" matBadgeIcon matBadgePosition="below" [matBadgeHidden]="!user.connection"
				[matBadgeColorize]="'mat-'+ user?.connection?.color"></mat-user-picture>
			<div fxLayout="column" style="line-height: 1.25em;">
				{{user.nomComplet}}
				<small class="mat-grey">{{ user.isActive ? user.fonctionAndVille : 'Compte AD désactivé' }}</small>
				<small class="mat-grey" *ngIf="_disableWithoutGUID && !user.guid">n'est pas un compte AD</small>
			</div>
		</div>
	</mat-option>
</mat-autocomplete>